'use strict';

import stringSimilarity from 'string-similarity'

angular.module('docketbook').
  controller('selectXeroContactController', function(addressBookService, xeroService, $rootScope, $scope, $state, $stateParams, Restangular, accessControl, $timeout, $q, uuid) {
    // Initialise variables to be used
    $scope.xeroContactSearchValue = "";
    $scope.contactSelectCallback = null;
    $scope.xeroContactSearchList = [];
    $scope.contactLoadingError = null;
    $scope.contactsSelected = [];
    $scope.xeroContactsList = [];

    if ( $scope.currentOrg != null ) {
      xeroService.getXeroContacts(function(contacts) {
        $scope.xeroContactsList = contacts;
      },function(err) {
        $scope.xeroContactsList = [];
      });
    }

    /***************************************/
    /***** Parent Controlled Functions *****/
    /***************************************/

    $scope.$parent.xeroContactSelectFromParent = function(cb) {
      $("#selectXeroContactModal").fadeIn(100);
      $scope.contactSelectCallback = cb;
      $scope.xeroContactSearchList = $scope.xeroContactsList;
      $scope.xeroContactSearchValue = "";
    }

    $scope.searchXeroContactChange = function(searchValue) {
      if ( searchValue == "" ) {
        $scope.xeroContactSearchList = $scope.xeroContactsList;
        return;
      }

      $scope.xeroContactSearchList = 
        $scope.xeroContactsList
        .filter(contact => 
          stringSimilarity.compareTwoStrings(contact.name, searchValue) > 0.5
          || contact.name.toLowerCase().indexOf(searchValue.toLowerCase()) != -1
        )
    }

    $scope.selectXeroContact = function(xeroContact) {
      $scope.xeroContactDetail = xeroContact;
    }

    $scope.closeXeroContactSelect = function() {
      $("#selectXeroContactModal").fadeOut(100);
    }

    $scope.assignXeroContact = function(xeroContact) {
      $scope.closeXeroContactSelect();
      $scope.contactSelectCallback(xeroContact);
    }

});



// WEBPACK FOOTER //
// ./src/controllers/selectors/selectXeroContactController.js